import React, { createContext, useState, useContext } from 'react';

// Create the WarehouseContext
const WarehouseContext = createContext();

// Custom hook to access WarehouseContext
export const useWarehouse = () => {
  return useContext(WarehouseContext);
};

// WarehouseProvider component
export const WarehouseProvider = ({ children }) => {
  const [picklists, setPicklists] = useState([]);
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);

  // Add a new picklist
  const addPicklist = (picklist) => {
    setPicklists((prevPicklists) => [...prevPicklists, picklist]);
  };

  // Add a new product
  const addProduct = (product) => {
    setProducts((prevProducts) => [...prevProducts, product]);
  };

  // Add a new order
  const addOrder = (order) => {
    setOrders((prevOrders) => [...prevOrders, order]);
  };

  return (
    <WarehouseContext.Provider
      value={{ picklists, products, orders, addPicklist, addProduct, addOrder }}
    >
      {children}
    </WarehouseContext.Provider>
  );
};
